module.exports = __webpack_public_path__ + "static/media/welcome-popup-logo.8a2ad2d4.png";